export const sortIdProofValues = (values = []) => {
  if (!Array.isArray(values)) return [];
  return [...values].sort((a, b) => {
    const left = String(a ?? '').trim().toLowerCase();
    const right = String(b ?? '').trim().toLowerCase();
    return left.localeCompare(right, undefined, { sensitivity: 'base' });
  });
};

export const sortConsentRecords = (records = []) => {
  if (!Array.isArray(records)) return [];

  const getComparableId = (row) => {
    const raw = row?.id ?? row?.ID ?? row?.consent_id ?? row?.consentId;
    if (raw === null || raw === undefined || raw === '') return null;
    const numeric = Number(raw);
    return Number.isNaN(numeric) ? String(raw).trim().toLowerCase() : numeric;
  };

  const getTimestamp = (row) => {
    const candidates = [
      row?.created_at,
      row?.createdAt,
      row?.created,
      row?.date_created,
      row?.dateCreated,
      row?.updated_at,
      row?.updatedAt,
    ];

    for (const value of candidates) {
      if (value === null || value === undefined || value === '') continue;
      const parsed = new Date(value);
      if (!Number.isNaN(parsed.getTime())) return parsed.getTime();
    }
    return null;
  };

  return [...records].sort((a, b) => {
    // 1. Stack order: Highest numeric ID = newest inserted record on top of the stack (LIFO)
    const leftId = getComparableId(a);
    const rightId = getComparableId(b);
    if (typeof leftId === 'number' && typeof rightId === 'number' && leftId !== rightId) {
      return rightId - leftId;
    }

    // 2. Fallback to newest creation timestamp
    const leftTs = getTimestamp(a);
    const rightTs = getTimestamp(b);
    if (leftTs != null && rightTs != null && leftTs !== rightTs) {
      return rightTs - leftTs;
    }
    if (leftTs != null && rightTs == null) return -1;
    if (leftTs == null && rightTs != null) return 1;

    // 3. Fallback to string-based ID comparison
    if (leftId != null && rightId != null && leftId !== rightId) {
      return String(rightId).localeCompare(String(leftId), undefined, { sensitivity: 'base' });
    }

    const left = String(a?.username || a?.name || a?.email || a?.id || '').trim().toLowerCase();
    const right = String(b?.username || b?.name || b?.email || b?.id || '').trim().toLowerCase();
    return left.localeCompare(right, undefined, { sensitivity: 'base' });
  });
};
